import React from 'react'
import { Badge } from 'antd'

export const SUPPLIER_INVITES_BADGE_COLORS = {
  pending: '#ff4d4f',
  defaultSuppliers: '#fa8c16',
}

export function shouldShowCountBadge(count) {
  return Number(count) > 0
}

export async function fetchSupplierInvitesCounts({
  username,
  apiGet,
  includeDefaultSuppliers = true,
}) {
  if (!username) {
    return {
      pendingCount: 0,
      defaultSuppliersCount: 0,
    }
  }

  const queryStringParameters = { username }
  let pendingCount = 0
  let defaultSuppliersCount = 0

  const pendingResponse = await apiGet('api2', 'suppliers/invites/count', {
    queryStringParameters,
  })

  if (pendingResponse?.success) {
    pendingCount = pendingResponse.count || 0
  }

  if (includeDefaultSuppliers) {
    const defaultResponse = await apiGet(
      'api2',
      'suppliers/default-suppliers/count',
      {
        queryStringParameters,
      },
    )

    if (defaultResponse?.success) {
      defaultSuppliersCount = defaultResponse.count || 0
    }
  }

  return {
    pendingCount,
    defaultSuppliersCount,
  }
}

export function SupplierInvitesTabLabel({ label, count, badgeColor }) {
  if (!shouldShowCountBadge(count)) {
    return label
  }

  return (
    <span>
      {label}
      <Badge
        count={count}
        style={{
          backgroundColor: badgeColor,
          marginLeft: 8,
        }}
      />
    </span>
  )
}

export function SupplierInvitesNavLabel({
  pendingCount,
  defaultSuppliersCount,
}) {
  return (
    <span>
      Supplier Invites
      {shouldShowCountBadge(pendingCount) ? (
        <Badge
          count={pendingCount}
          style={{
            backgroundColor: SUPPLIER_INVITES_BADGE_COLORS.pending,
            marginLeft: 8,
          }}
        />
      ) : null}
      {shouldShowCountBadge(defaultSuppliersCount) ? (
        <Badge
          count={defaultSuppliersCount}
          style={{
            backgroundColor: SUPPLIER_INVITES_BADGE_COLORS.defaultSuppliers,
            marginLeft: 4,
          }}
        />
      ) : null}
    </span>
  )
}
